<template>
  <div id="app">
    <div class="cont">
      <div class="btn" @click="down">
        <img src="./assets/pic_btn.png" alt="">
      </div>
    </div>
    <div class="wechatCover" v-if="isWeixin">
      <img src="./assets/safari.png" alt="">
    </div>
  </div>
</template>

<script>

import './sass/index.min.css'

import { Toast } from 'vant'

export default {
  name: 'App',
  components: {

  },
  data(){
    return{
      isWeixin: false,// 是否微信内打开
    }
  },
  methods: {
    getData(){

    },

    // 下载
    down(e){
      const type = e.currentTarget.dataset.type;
      const androidUrl = 'http://static.whyangshi.com/apk/%E8%81%9A%E6%98%9F%E6%B4%BE%E5%AF%B9_%5Bgongzhonghao%5D_release.apk';
      let iosUrl = 'http://qzjywl1.cn/ku2urz';
      console.log(getQueryString('url'));
      if(getQueryString('url')){
        iosUrl = decodeURI(getQueryString('url'));
        console.log(iosUrl);
      }
      if(isiOS){
        window.location.href = iosUrl;
      }else{
        window.location.href = androidUrl;
      }
    },
  },
  mounted () {
    this.isWeixin = isWeixin || this.isWeixin;
  }
}
</script>

